import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';

import LandingPage from 'landing_pages/components';
import { fetchPageIfNeeded } from 'landing_pages/ducks';
import { fetchReviewStatsIfNeeded } from 'marketing/ducks';
import { getVariation } from 'common/optimize';

LandingPage.need = [
  params => fetchPageIfNeeded(params),
  fetchReviewStatsIfNeeded
];

/* replace block data with assigned Optimize experiment variation, if any */
const setBlockVariations = (landingPage, state) => {
  const { pageBlockExperiments } = state.landing_pages;
  let updatedLandingPage = landingPage, currentExperiments = [];

  if (landingPage) {
    updatedLandingPage = {
      ...landingPage,
      page_blocks: (landingPage.page_blocks || []).map(block => {
        const experiment = pageBlockExperiments.find(exp => (
          exp.block_type === block.block_type &&
          (!exp.block_name || exp.block_name === block.block_name)
        ));

        if (experiment) {
          const variation = getVariation(experiment.external_id, state);
          currentExperiments = currentExperiments.concat(
            { id: experiment.external_id, variationId: variation }
          );

          return {
            ...block,
            data: variation === 0? block.data : experiment.variations[variation - 1].data
          };
        }

        return block;
      })
    };
  };

  return { landingPage: updatedLandingPage, currentBlockExperiments: currentExperiments };
}

/* replace page data with assigned Optimize experiment variation, if any */
const setPageVariation = (landingPage, state) => {
  const { pageExperiments } = state.landing_pages;
  let updatedLandingPage = landingPage, currentExperiments = [];

  if (landingPage) {
    const experiment = pageExperiments.find(exp => exp.landing_page === landingPage.id);

    if (experiment) {
      const variation = getVariation(experiment.external_id, state);
      currentExperiments = currentExperiments.concat(
        { id: experiment.external_id, variationId: variation }
      );

      updatedLandingPage = {
        ...landingPage,
        page_blocks: (
          variation === 0? landingPage.page_blocks : experiment.variations[variation - 1].page_blocks
        )
      };
    }
  }

  return { landingPage: updatedLandingPage, currentPageExperiments: currentExperiments };
}

const hasFaqs = (landingPage) => {
  if (!landingPage) {
    return false;
  }

  /* page blocks that define FAQs... */
  return !!(landingPage.page_blocks || []).find(b => (
    ["faq", "how_it_works_2"].includes(b.block_type)
  ));
}

export function mapStateToProps(state) {
  const { landing_pages } = state;
  let currentPageExperiments, currentBlockExperiments, landingPage;
  ({ currentPageExperiments, landingPage } = setPageVariation(landing_pages.landing_page, state));
  ({ currentBlockExperiments, landingPage } = setBlockVariations(landingPage, state));

  return {
    ...landing_pages,
    landing_page: landingPage,
    hasFaqs: hasFaqs(landingPage),
    currentExperiments: [ ...currentPageExperiments, ...currentBlockExperiments ]
  };
}

export function mapDispatchToProps(dispatch, { params }) {
  const actions = {
    fetch: partial(fetchPageIfNeeded, params),
  };

  return bindActionCreators(actions, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LandingPage));
